import {AiOutlineInstagram} from "react-icons/ai"
import {AiOutlineTwitter} from "react-icons/ai"
import {AiOutlineGithub} from "react-icons/ai"
import {AiOutlineLinkedin} from "react-icons/ai"




const data=[
    {id:1,link:'https://www.instagram.com/iamashmit18/',icon:<AiOutlineInstagram/>},
    {id:2,link:'https://twitter.com/AshmitYadav11',icon:<AiOutlineTwitter/>},
    {id:3,link:'https://github.com/Ashmit-1131',icon:<AiOutlineGithub/>},
    {id:4,link:'https://www.linkedin.com/in/ashmit-yadav-588192228/',icon:<AiOutlineLinkedin/>},
    
]
export default data;